module.exports = __webpack_public_path__ + "static/media/olive.2eadcc7b.png";